import { ReactNode } from "react";

import PostHogAnalyticsProvider from "common/contexts/PostHogAnalyticsProvider";

import { INITIAL_CLIENT_DATA } from "client/common/utils";

type ClientAnalyticsProviderProps = {
  children: ReactNode;
};

const ClientAnalyticsProvider = ({ children }: ClientAnalyticsProviderProps) => {
  return (
    <PostHogAnalyticsProvider
      isEnabled={INITIAL_CLIENT_DATA.has_internal_analytics_tracking}
      userId={INITIAL_CLIENT_DATA.user_id}
    >
      {children}
    </PostHogAnalyticsProvider>
  );
};

export default ClientAnalyticsProvider;
